<template>
  <fb-form-body>
    <el-form :model="formData" ref="form" label-position="top">
      <el-form-item :label="`${$t('lang.食谱分类')}、${$t('lang.食谱标签')}、${$t('lang.配件库支持以下语言')}：`">
        <el-row :gutter="24">
          <el-checkbox-group v-model="formData.checkList">
            <el-col :span="6" v-for="lang in langList" :key="lang.value + '_key'">
              <el-checkbox :label="lang.value">{{ lang.name }}（{{ lang.value }}）</el-checkbox>
            </el-col>
          </el-checkbox-group>
        </el-row>

      </el-form-item>


      <el-form-item>
        <el-button type="primary" @click="handleSubmit('form')">{{ $t('lang.保存') }}</el-button>
        <el-button @click="handleReset('form')">{{ $t('lang.重置') }}</el-button>
      </el-form-item>
    </el-form>
  </fb-form-body>
</template>

<script>
import {loadSysSettLang} from "../../js/common";

export default {
  name: "LangSet",
  data() {
    return {
      api: {
        update: this.$api.sysSupportLang.update,
        list: this.$api.sysSupportLang.list,
      },
      formErrorMsg: {name: ''},
      formData: {
        checkList: []
      },
    }
  },
  computed: {
    langList() {
      return this.$store.state.supportLangList;
    }


  },
  methods: {
    handleSubmit(form) {
      let vm = this;
      vm.$refs[form].validate((valid) => {
        if (valid) {
          vm.$http.post(vm.api.update, this.formData['checkList']).then((resp) => {

            if (resp.data.status === 200) {
              vm.$message({
                type: 'success',
                message: resp.data.desc
              });
              loadSysSettLang(this);
              this.$emit("save");
            } else if (resp.data.status === 400) {

              vm.$message({
                type: "error",
                message: this.$t('lang.' +resp.data.desc)
              });
            } else {
              vm.$message({
                type: "error",
                message: this.$t('lang.' +resp.data.desc)
              })
            }

          });
          return true;
        } else {
          return false;
        }
      });

    },
    handleReset(form) {
      this.$refs[form].resetFields();
      this.formData['checkList'] = [];
    }
  },

  created() {
    let vm = this;
    this.$http.post(this.api.list).then(function (resp) {
      if(resp.data.status != 200) {
        vm.$message.error(resp.data.desc);
        return;
      }
      vm.formData['checkList'] = resp.data.data['lang'];
    });

  }
}
</script>

<style scoped>

</style>
